import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { langLink, translateLive } from '../../../../../services/i18n-live';
import { PackageCardVM } from '../../../../common/package-grid/package-grid.component';

/** Shape of one `home.pckgs` entry in assets/i18n/*.json. */
interface HomePackage {
  type: string;
  lessonsQty?: string[];
  price: string;
  icon: string;
  description?: string;
  bgColor: string;
  fontColor: string;
}

/** The part of the `home` translations this section reads. */
interface HomeTexts {
  design?: { coursesIntro?: string };
  whatWeOffer?: string;
  ourPackages?: string;
  'packages-intro'?: string;
  'see-more'?: string;
  pckgs?: HomePackage[];
}

@Component({
  selector: 'app-home-packages',
  templateUrl: './home-packages.component.html',
  styleUrl: './home-packages.component.css',
})
export class HomePackagesSectionComponent {
  private readonly translate = inject(TranslateService);
  texts = { kicker: '', title: '', intro: '', seeMore: '' };
  cards: PackageCardVM[] = [];

  constructor() {
    // All copy comes from one live source: the translate pipe can show a stale language when
    // two language loads overlap (e.g. a stored language and the URL's), translateLive cannot.
    translateLive<HomeTexts>(this.translate, 'home')
      .pipe(takeUntilDestroyed())
      .subscribe((home) => {
        this.texts = {
          kicker: home.whatWeOffer ?? '',
          title: home.ourPackages ?? '',
          intro: home.design?.coursesIntro ?? home['packages-intro'] ?? '',
          seeMore: home['see-more'] ?? '',
        };
        this.cards = (Array.isArray(home.pckgs) ? home.pckgs : []).map((p) => ({
          type: p.type,
          lines: p.lessonsQty ?? [],
          price: p.price,
          icon: p.icon,
          description: p.description,
          bgColor: p.bgColor,
          fontColor: p.fontColor,
        }));
      });
  }

  link(route: string): string {
    return langLink(this.translate, route);
  }
}
